// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3BZ_e","clinicsSelect":"TableHeading_clinicsSelect__3NP05"};